import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHeart, faSmile, faEnvelope, faFlag, faClose } from '@fortawesome/free-solid-svg-icons';
import { ApiServicesService } from '../services/api-services.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink, NavigationEnd } from '@angular/router';
import { UserDetailsService } from '../services/user-details.service';
import { SnackbarService } from '../services/snackbar.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-suggestion-user',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, RouterLink],
  templateUrl: './suggestion-user.component.html',
  styleUrl: './suggestion-user.component.css'
})

export class SuggestionUserComponent {
  baseUrl: string = 'http://localhost:4200';

  faheart = faHeart;
  faaclose = faClose;

  suggestionUser: any;
  sugUserId: any
  loader: boolean = true;
  availSugUser: boolean = true;

  private routerSubscription!: Subscription;

  profileComplete: any;

  constructor(private apiservices: ApiServicesService, private userdetails: UserDetailsService, private snackbarService: SnackbarService, private router: Router, private route: ActivatedRoute) { }
  previousUrl: any = '';

  private userDetailsSubscription!: Subscription;
  ngOnInit() {
    this.getSuguser();

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('member-profile')) {
          const currentUrl = event.urlAfterRedirects;
          const currentUrlSplit = currentUrl?.split("/") || [];
          const previousUrlSplit = this.previousUrl?.split("/") || [];

          if (
            currentUrlSplit.length > 2 &&
            previousUrlSplit.length > 2 &&
            currentUrlSplit[2] !== previousUrlSplit[2]
          ) {
            this.getSuguser();
          } else if (previousUrlSplit.length == 1) {
            this.getSuguser();
          }

          this.previousUrl = currentUrl;
        }
      }
    });
  }





  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }



  view_member(username: any) {
    const userdata = localStorage.getItem('encryptedUserData');
    if (userdata) {
      const decryptedData = this.apiservices.decryptData(userdata);
      if (decryptedData && decryptedData.user) {
        // console.log(decryptedData, 'decryptedData')
        this.profileComplete = decryptedData.user.profileCompleteness == 1 ? true : false;
      }
    }

    if (this.profileComplete == true) {
      this.router.navigate(['/member-profile', username, 'Profile']);
    } else {
      this.snackbarService.openCustomSnackbar(
        {
          icon: false,
          message: 'Complete Your profile before using this feature',
          className: 'failed',
        }
      );
    }
  }



  getSuguser() {
    this.loader=true;
    this.apiservices.getSuguser().subscribe({
      next: (suguser: any) => {
        if (suguser.status == 200) {
          if (suguser && suguser.profiles && suguser.profiles.length > 0) {
            this.suggestionUser = suguser.profiles[0];
            this.sugUserId = this.suggestionUser.id;
            this.availSugUser = this.suggestionUser;
            this.loader = false;
            // console.log('suggestionUser',this.suggestionUser)
          } else {
            this.availSugUser = false;
            this.loader = false;
          }
        } else {
          this.availSugUser = false;
          this.loader = false;
          // this.snackbarService.openCustomSnackbar(
          //   {
          //     icon: false,
          //     message: suguser.message,
          //     className: 'failed',
          //   }
          // );
        }
      },
      error: (err) => {
        this.availSugUser = false;
        this.loader = false;
      }
    });
  }

  acceptSugUser() {


    const userdata = localStorage.getItem('encryptedUserData');
    if (userdata) {
      const decryptedData = this.apiservices.decryptData(userdata);
      if (decryptedData && decryptedData.user) {
        // console.log(decryptedData, 'decryptedData')
        this.profileComplete = decryptedData.user.profileCompleteness == 1 ? true : false;
      }
    }

    if (this.profileComplete == true) {

      this.apiservices.acceptSugUser(this.sugUserId).subscribe({
        next: (suguser: any) => {
          if (suguser.status == 200) {
            this.loader = false;
            this.snackbarService.openCustomSnackbar(
              {
                icon: true,
                message: suguser.message,
                className: 'success',
              }
            );
            if (suguser && suguser?.data?.suggestions && suguser?.data?.suggestions?.length > 0) {
              this.suggestionUser = suguser?.data.suggestions[0];
              this.sugUserId = this.suggestionUser?.id;
              this.availSugUser = this.suggestionUser;
              this.loader = false;
            } else {
              this.availSugUser = false;
            }
          } else {
            this.loader = false;
            this.availSugUser = false;
            this.snackbarService.openCustomSnackbar(
              {
                icon: false,
                message: suguser.message,
                className: 'failed',
              }
            );
  
          }
        },
        error: (err) => {
          console.error('Error fetching states:', err);
        }
      });
      
    } else {
      this.snackbarService.openCustomSnackbar(
        {
          icon: false,
          message: 'Complete Your profile before using this feature',
          className: 'failed',
        }
      );
    }
 
  }

  ignoreSugUsder() {


    const userdata = localStorage.getItem('encryptedUserData');
    if (userdata) {
      const decryptedData = this.apiservices.decryptData(userdata);
      if (decryptedData && decryptedData.user) {
        // console.log(decryptedData, 'decryptedData')
        this.profileComplete = decryptedData.user.profileCompleteness == 1 ? true : false;
      }
    }

    if (this.profileComplete == true) {

      this.apiservices.ignoreSugUser(this.sugUserId).subscribe({
        next: (suguser: any) => {
          if (suguser.status == 200) {
            this.snackbarService.openCustomSnackbar(
              {
                icon: true,
                message: suguser.message,
                className: 'success',
              }
            );
            if (suguser && suguser.data.suggestions && suguser.data.suggestions.length > 0) {
              this.suggestionUser = suguser.data.suggestions[0];
              this.sugUserId = this.suggestionUser.id;
              this.availSugUser = this.suggestionUser;
              this.loader = false;
            } else {
              this.availSugUser = false;
            }
          } else {
  
            this.availSugUser = false;
            this.loader = false;
            this.snackbarService.openCustomSnackbar(
              {
                icon: false,
                message: suguser.message,
                className: 'failed',
              }
            );
  
          }
        },
        error: (err) => {
          console.error('Error fetching states:', err);
        }
      });

    } else {
      this.snackbarService.openCustomSnackbar(
        {
          icon: false,
          message: 'Complete Your profile before using this feature',
          className: 'failed',
        }
      );
    }


    
  }
}